import React from "react";

export const HowAddTrackInAlbum: React.FC = () => {
  return <div id={"HowAddTrackInAlbum"}>
    <h2>
      Как добавить новый трек в опубликованный альбом
    </h2>
    <ul className={"list-disc"}>
      <li>
        Откройте альбом и нажмите Черновик
      </li>
      <li>
        Перейдите во вкладку Трек-лист и добавьте новый трек, перетащите его в нужное положение
      </li>
      <li>
        Заполните поля с информацией о треке, настройте Финансовые модели
      </li>
      <li>
        Сохраните изменения и нажмите Опубликовать
      </li>
    </ul>
  </div>;
};
